import { HsListResult } from './Models/HsListResult';
import { HsContext } from '../../Utils';

export default class HubSpotClient {
    portalId: string;
    context: HsContext;
    entitiesPerPage: number;
    endpointUrl: string;

    constructor(portalId: string, endpointUrl: string, context: HsContext, entitiesPerPage: number) {
        this.portalId = portalId;
        this.endpointUrl = endpointUrl;
        this.context = context;
        this.entitiesPerPage = entitiesPerPage;
    }

    async getHubSpotResults(query: string, offset: number = 0) {
        const params = new URLSearchParams();
        params.append('portalId', this.portalId);
        params.append('term', query);
        params.append('limit', this.entitiesPerPage.toString());
        params.append('pathPrefix',  this.buildPathPrefix([this.context.language, this.context.store]));
        params.append('analytics',  'false');

        if (offset > 0) {
            params.append('offset', offset.toString());
        }

        let url = `${this.endpointUrl}?${params.toString()}`

        const response = await fetch(url);
        const result = (await response.json()) as HsListResult;
        return result;
    }

    private buildPathPrefix(segments: string[]) {
        return segments.filter(Boolean).join('/');
    }
}
